import { cn } from 'designSystem/lib/utils'
import * as React from 'react'

type HiddenFileInputProps = Omit<React.ComponentProps<'input'>, 'type'>

/**
 * A file input driven by a visible button. Kept in the layout as a
 * screen-reader-only element rather than `display: none`, which Android
 * WebViews refuse to open a picker for.
 */
export const HiddenFileInput = React.forwardRef<
  HTMLInputElement,
  HiddenFileInputProps
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type='file'
    data-slot='hidden-file-input'
    className={cn('sr-only', className)}
    {...props}
  />
))
HiddenFileInput.displayName = 'HiddenFileInput'
